export const BOM_WAREHOUSES_REQUIRED_MESSAGE = 'A BOM must have at least one warehouse.';
//# sourceMappingURL=bom-warehouses-required-message.js.map